import { portableTextWithInternalLinks } from '../utils/portableText'

export const teasingVideoBlock = `
_type == 'teasingVideoBlock' => {
  "success_text": success_text[_key == $lang][0].value[] {
    ${portableTextWithInternalLinks}
  },
}
`
